<template>
  <div>
    <loading v-if="loadingRender"></loading>

    <panel
      Title="تنظیمات کلی"
      Des="در این منو می‌توانید تنظیمات مربوط به درگاه های پرداخت و دیگر تنظیمات کلی در سامانه خود را انجام دهید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <ul class="nav bnp-tabs" id="nav-tab" role="tablist" dir="rtl">
          <li class="bnp-tabs__item">
            <a
              class="bnp-tabs__link active"
              id="nav-home-tab"
              data-toggle="tab"
              href="#nav-home"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
            >
              تنظیمات درگاه پرداخت</a
            >
          </li>
          <li class="bnp-tabs__item">
            <a
              class="bnp-tabs__link"
              id="nav-Account-tab"
              data-toggle="tab"
              href="#nav-Account"
              role="tab"
              aria-controls="nav-Account"
              aria-selected="false"
              >تنظیمات حساب ها</a
            >
          </li>
          <li class="bnp-tabs__item">
            <a
              class="bnp-tabs__link"
              id="nav-Settings-tab"
              data-toggle="tab"
              href="#nav-Settings"
              role="tab"
              aria-controls="nav-Settings"
              aria-selected="false"
              >تنظیمات سامانه</a
            >
          </li>
          <li
            v-if="$session.get('CustCode') == '945'"
            class="bnp-tabs__item"
          >
            <a
              class="bnp-tabs__link"
              id="nav-Account-Setting-tab"
              data-toggle="tab"
              href="#nav-Account-Setting"
              role="tab"
              aria-controls="nav-Account-Setting"
              aria-selected="false"
              >تنظیمات حساب بانکی</a
            >
          </li>
          <li v-if="EnableRobot" class="bnp-tabs__item">
            <a
              class="bnp-tabs__link"
              id="nav-Robot-Setting-tab"
              data-toggle="tab"
              href="#nav-Robot-Setting"
              role="tab"
              aria-controls="nav-Robot-Setting"
              aria-selected="false"
              >تنظیمات بازو</a
            >
          </li>
        </ul>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="nav-home"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
          >
            <div
              ref="gatewayAnchor"
              class="gw-toolbar-anchor"
              :style="toolbarPinned ? { height: toolbarHeight + 'px' } : null"
            >
              <div
                ref="gatewaySentinel"
                class="gw-sentinel"
                aria-hidden="true"
              ></div>
              <div
                class="gw-toolbar"
                :class="{
                  'is-editing': EditMode,
                  'is-fixed': toolbarPinned,
                }"
                :style="toolbarPinned ? pinStyle : null"
                dir="rtl"
              >
                <div class="gw-summary">
                  <span>{{ Menu.length }} درگاه</span>
                </div>
                <div class="gw-actions">
                  <template v-if="EditMode">
                    <button
                      type="button"
                      class="gw-btn gw-btn--ghost"
                      :disabled="$store.state.loading"
                      @click="cancelGatewayEdit"
                    >
                      انصراف
                    </button>
                    <button
                      type="button"
                      class="gw-btn gw-btn--save"
                      :disabled="$store.state.loading"
                      @click="updatemenu"
                    >
                      <i class="fas fa-check" aria-hidden="true"></i>
                      ثبت اطلاعات
                    </button>
                  </template>
                  <button
                    v-else
                    type="button"
                    class="gw-btn gw-btn--edit"
                    :disabled="Menu.length === 0"
                    @click="startGatewayEdit"
                  >
                    <i class="fas fa-edit" aria-hidden="true"></i>
                    اصلاح
                  </button>
                </div>
              </div>
            </div>
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-list-alt"></i> تنظیمات درگاه پرداخت
                </h6>
              </template>
              <template slot="content">
                <p v-if="Menu.length === 0" class="gw-empty">
                  درگاهی برای نمایش وجود ندارد.
                </p>
                <div v-else class="gw-list" dir="rtl">
                  <article
                    v-for="(item, index) in Menu"
                    :key="item.id != null ? item.id : index"
                    class="gw-item"
                  >
                    <div class="gw-item__head">
                      <span class="gw-index">{{ index + 1 }}</span>
                      <div class="gw-name">
                        <input
                          v-if="EditMode"
                          type="text"
                          v-model="item.persianName"
                          aria-label="نام درگاه"
                        />
                        <span v-else>{{ item.persianName || "—" }}</span>
                      </div>
                      <label
                        class="gw-flag"
                        :class="{ 'is-disabled': !EditMode }"
                      >
                        <span>پیش‌فرض</span>
                        <span class="gw-switch">
                          <input
                            type="checkbox"
                            v-model="item.isDefault"
                            :disabled="!EditMode"
                            :aria-label="'پیش‌فرض ' + (item.persianName || '')"
                          />
                          <span class="gw-switch__track" aria-hidden="true"></span>
                        </span>
                      </label>
                    </div>

                    <div class="gw-fields">
                      <label class="gw-field">
                        <small>کد درگاه</small>
                        <input
                          v-if="EditMode"
                          type="text"
                          dir="ltr"
                          v-model="item.gatewayCode"
                        />
                        <span v-else class="gw-value" dir="ltr">{{
                          item.gatewayCode || "—"
                        }}</span>
                      </label>
                      <label class="gw-field gw-field--wide">
                        <small>آدرس برگشت</small>
                        <input
                          v-if="EditMode"
                          type="text"
                          dir="ltr"
                          v-model="item.callBackUrl"
                        />
                        <span
                          v-else
                          class="gw-value"
                          dir="ltr"
                          :title="item.callBackUrl"
                          >{{ item.callBackUrl || "—" }}</span
                        >
                      </label>
                      <label class="gw-field">
                        <small>بازه فعالیت درگاه</small>
                        <input
                          v-if="EditMode"
                          type="text"
                          class="is-center"
                          v-model="item.activeDay"
                        />
                        <span v-else class="gw-value is-center">{{
                          item.activeDay || "—"
                        }}</span>
                      </label>
                    </div>

                    <div class="gw-flags">
                      <label
                        class="gw-flag"
                        :class="{ 'is-disabled': !EditMode }"
                      >
                        <span>امکان تغییر مبالغ</span>
                        <span class="gw-switch">
                          <input
                            type="checkbox"
                            v-model="item.isFixVarizGhest"
                            :disabled="!EditMode"
                            :aria-label="'امکان تغییر مبالغ ' + (item.persianName || '')"
                          />
                          <span class="gw-switch__track" aria-hidden="true"></span>
                        </span>
                      </label>
                      <label
                        class="gw-flag"
                        :class="{ 'is-disabled': !EditMode }"
                      >
                        <span>عدم تغییر مبلغ در صورت داشتن جریمه</span>
                        <span class="gw-switch">
                          <input
                            type="checkbox"
                            v-model="item.IsFixVarizGhestHasJarime"
                            :disabled="!EditMode"
                            :aria-label="'عدم تغییر مبلغ در صورت داشتن جریمه ' + (item.persianName || '')"
                          />
                          <span class="gw-switch__track" aria-hidden="true"></span>
                        </span>
                      </label>
                    </div>
                  </article>
                </div>
              </template>
            </net-pa-card>
          </div>
          <div
            class="tab-pane fade"
            id="nav-Account"
            role="tabpanel"
            aria-labelledby="nav-Account-tab"
          >
            <!-- Mahdodiat Enteghal -->
            <net-pa-card
              :IsMinus="true"
              :IdElement="'TransferSetting'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-list-alt"></i> تنظیم محدودیت
                  <b class="text-danger">انتقال</b> وجه
                </h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-4 col-12">
                    <small>انتخاب حساب </small>
                    <select
                      class="form-control Pointer mt-2"
                      v-model="DataAxios.wwwtblnoe"
                      @change="ChangeNoe(false)"
                    >
                      <option :value="-1">-- انتخاب حساب --</option>

                      <option
                        v-for="item in this.ListModel2"
                        :key="item.id"
                        :value="item"
                      >
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div
                    class="col-md-4 col-12"
                    v-if="
                      DataAxios.wwwtblnoeId != -1 &&
                      DataAxios.wwwtblnoeId != null
                    "
                  >
                    <small>حداکثر مبلغ قبلی</small> {{ $GetVahedPool() }}
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      disabled
                      style="font-size: 16px"
                      @keyup="$PutCommatoInput()"
                      type="text"
                      v-model="DataAxios.wwwtblnoe.maxMabEnteghalDarMah"
                    />
                  </div>
                  <div
                    class="col-md-4 col-12"
                    v-if="
                      DataAxios.wwwtblnoeId != -1 &&
                      DataAxios.wwwtblnoeId != null
                    "
                  >
                    <small>حداکثر مبلغ انتقال در روز</small>
                    {{ $GetVahedPool() }}
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      style="font-size: 16px"
                      @keyup="$PutCommatoInput()"
                      type="text"
                      v-model="DataAxios.Amount"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 col-12 text-center"></div>
                  <div class="col-md-2 col-12 text-center">
                    <button
                      v-if="
                        DataAxios.wwwtblnoeId != -1 &&
                        DataAxios.wwwtblnoeId != null
                      "
                      class="btn btn-success rounded mt-4 w-100"
                      @click="SetTaahodatList(false)"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Mahdodiat Bardasht -->
            <net-pa-card
              class="mt-4"
              :IsMinus="true"
              :IdElement="'DebtorSetting'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-list-alt"></i> تنظیم محدودیت
                  <b class="text-warning">برداشــت </b>وجه
                </h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-3 col-12">
                    <small>انتخاب حساب </small>
                    <select
                      class="form-control Pointer mt-2"
                      v-model="DataAxiosBardasht.wwwtblnoe"
                      @change="ChangeNoe(true)"
                    >
                      <option :value="-1">-- انتخاب حساب --</option>
                      <option
                        v-for="item in this.ListModel2"
                        :key="item.id"
                        :value="item"
                      >
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div
                    class="col-md-3 col-12"
                    v-if="
                      DataAxiosBardasht.wwwtblnoeId != -1 &&
                      DataAxiosBardasht.wwwtblnoeId != null
                    "
                  >
                    <small>حداکثر مبلغ قبلی</small> {{ $GetVahedPool() }}
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      disabled
                      style="font-size: 16px"
                      @keyup="$PutCommatoInput()"
                      type="text"
                      v-model="DataAxiosBardasht.wwwtblnoe.maxMabBardashtDarRoz"
                    />
                  </div>
                  <div
                    class="col-md-3 col-12"
                    v-if="
                      DataAxiosBardasht.wwwtblnoeId != -1 &&
                      DataAxiosBardasht.wwwtblnoeId != null
                    "
                  >
                    <small>حداکثر مبلغ انتقال در روز</small>
                    {{ $GetVahedPool() }}
                    <input
                      class="form-control mt-2 text-center 3ragham text-danger"
                      style="font-size: 16px"
                      @keyup="$PutCommatoInput()"
                      type="text"
                      v-model="DataAxiosBardasht.Amount"
                    />
                  </div>
                  <div
                    class="col-md-3 col-12"
                    v-if="
                      $session.get('CustCode') == '948' &&
                      DataAxiosBardasht.wwwtblnoeId != -1 &&
                      DataAxiosBardasht.wwwtblnoeId != null
                    "
                  >
                    <small> برداشت وجه در صورت تسهیلات معوق</small>
                    <span class="form-control p-1 mt-2">
                      <div class="custom-control custom-switch text-center">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="withdrawalIfLoanIsDelayed"
                          v-model="
                            DataAxiosBardasht.wwwtblnoe
                              .withdrawalIfLoanIsDelayed
                          "
                        />
                        <label
                          class="custom-control-label p-1"
                          for="withdrawalIfLoanIsDelayed"
                          >فعال
                        </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 col-12 text-center"></div>
                  <div class="col-md-2 col-12 text-center">
                    <button
                      v-if="
                        DataAxiosBardasht.wwwtblnoeId != -1 &&
                        DataAxiosBardasht.wwwtblnoeId != null
                      "
                      class="btn btn-success rounded mt-4 w-100"
                      @click="SetTaahodatList(true)"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Tanzimat Peyvast hesabha -->
            <net-pa-card
              class="mt-4"
              :IsMinus="true"
              :IdElement="'Atachment'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-list-alt"></i> تنظیم پیوست حساب‌ها
                </h6>
              </template>
              <template slot="content">
                <div class="row" style="margin: unset">
                  <div
                    class="alert alert-danger w-100 text-danger font-weight-bold text-center"
                  >
                    کاربر گرامی : این بخش بهتر است توسط تیم برنامه نویس شرکت
                    پاسارگاد تنظیم و تکمیل گردد
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 col-12">
                    <small>انتخاب حساب </small>
                    <select
                      class="form-control Pointer mt-2"
                      style="font-size: 16px"
                      v-model="DataAxiosTashilat.wwwtblnoe"
                      @change="ChangeTashilatNoe()"
                    >
                      <option :value="-1">-- انتخاب حساب --</option>
                      <option
                        v-for="item in this.ListTashilat"
                        :key="item.id"
                        :value="item"
                      >
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-8 col-12">
                    <small> نام SP (پیوستی محاسبات) مربوطه </small>
                    <input
                      class="form-control mt-2 text-left text-danger"
                      dir="ltr"
                      style="font-size: 16px"
                      type="text"
                      v-model="DataAxiosTashilat.SP"
                    />
                  </div>
                  <div class="col-md-4 col-12 text-right mt-2">
                    <small> تنظیمات نمایش نفر X بر حسب امتیاز مکتسبه</small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="isShowMessage"
                          v-model="DataAxiosTashilat.ShowMessageZeroScore"
                        />
                        <label
                          class="custom-control-label p-1"
                          for="isShowMessage"
                          >نمایش
                        </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-8 col-12 mt-2 text-right">
                    <small
                      >پیغام در صورت نفر صفـــر بودن بر حسب امتیاز مکتسبه</small
                    >
                    <input
                      class="form-control mt-1"
                      v-model="DataAxiosTashilat.MessageZeroScore"
                    />
                  </div>
                  <div class="col-md-4 col-12 text-right mt-2">
                    {{ DataAxiosTashilat.ShowScore }}
                    <small> تنظیمات نمایش امتیاز </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="IsShowScore"
                          v-model="DataAxiosTashilat.ShowScore"
                        />
                        <label
                          class="custom-control-label p-1"
                          for="IsShowScore"
                          >نمایش
                        </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 col-12 text-center"></div>
                  <div class="col-md-2 col-12 text-center mt-1">
                    <button
                      class="btn btn-success rounded mt-4 w-100"
                      style="font-size: 16px"
                      @click="SetTashilatList"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Tanzimat Brge Saham -->
            <net-pa-card
              v-if="
                Number(
                  $session.get('UserInfoNetPa').custCode == 868 ||
                    $session.get('UserInfoNetPa').custCode == 574 ||
                    $session.get('UserInfoNetPa').custCode == 886 ||
                    $session.get('UserInfoNetPa').custCode == 932 ||
                    $session.get('UserInfoNetPa').custCode == 352 ||
                    $session.get('UserInfoNetPa').custCode == 850 ||
                    $session.get('UserInfoNetPa').custCode == 8002 ||
                    $session.get('UserInfoNetPa').custCode == 874,
                )
              "
              class="mt-4"
              :IsMinus="true"
              :IdElement="'Saham'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-list-alt"></i> تنظیم برگه سهـــــــــــام
                </h6>
              </template>
              <template slot="content">
                <div id="BargeSaham" class="row">
                  <div class="col-md-6 col-12">
                    <div class="row">
                      <div class="col-md-6 col-12 mt-3">
                        <small>انتخاب حساب </small>
                        <select
                          class="form-control Pointer required"
                          v-model="DataAxiosSaham.wwwtblNoeId"
                        >
                          <!-- <option  :value="-1">-- انتخاب حساب مورد نظر --</option> -->
                          <option
                            v-for="item in this.ListTashilat"
                            :key="item.id"
                            :value="item.id"
                          >
                            <span>{{ item.desNoe }} </span>
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6 col-12 mt-3">
                        <small> شماره ثبت</small>
                        <input
                          class="form-control text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.shomareSabt"
                        />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> تاریخ ثبت</small>
                        <date-picker
                          input-class="required form-control"
                          :editable="true"
                          :auto-submit="true"
                          color="#fa0"
                          v-model="DataAxiosSaham.tarixSabt"
                        >
                        </date-picker>
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> ارزش هر سهم {{ $GetVahedPool() }}</small>
                        <input
                          class="form-control text-center font-weight-bold 3ragham required"
                          dir="ltr"
                          type="text"
                          @keyup="$PutCommatoInput()"
                          v-model="DataAxiosSaham.arzeshHarSahm"
                        />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> مشخصات رئیس هیئت مدیره</small>
                        <input
                          class="form-control text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.pishNevis1"
                        />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> مشخصات مدیر عامل</small>
                        <input
                          class="form-control text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.pishNevis2"
                        />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> سریال</small>
                        <input
                          class="form-control text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.serialNumber"
                        />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> شناسه ملی </small>
                        <input
                          class="form-control text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.shenaseMeli"
                        />
                      </div>
                      <div class="col-md-12 col-12 mt-2 text-right">
                        <small
                          >پیغام در صورت نفر صفـــر بودن بر حسب امتیاز
                          مکتسبه</small
                        >
                        <input
                          class="form-control mt-1"
                          v-model="DataAxiosSaham.MessageZeroScore"
                        />
                      </div>
                      <div class="col-md-6 col-12 text-right mt-2">
                        <small> تنظیمات نمایش نفر X بر حسب امتیاز مکتسبه</small>
                        <span class="form-control p-1 mt-1">
                          <div class="custom-control custom-switch text-center">
                            <input
                              type="checkbox"
                              class="custom-control-input InputText"
                              id="isShowMessageSaham"
                              v-model="DataAxiosSaham.ShowMessageZeroScore"
                            />
                            <label
                              class="custom-control-label p-1"
                              for="isShowMessageSaham"
                              >نمایش
                            </label>
                          </div>
                        </span>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-2">
                        {{ DataAxiosSaham.ShowScore }}
                        <small> تنظیمات نمایش امتیاز </small>
                        <span class="form-control p-1 mt-1">
                          <div class="custom-control custom-switch text-center">
                            <input
                              type="checkbox"
                              class="custom-control-input InputText"
                              id="isShowScore"
                              v-model="DataAxiosSaham.ShowScore"
                            />
                            <label
                              class="custom-control-label p-1"
                              for="isShowScore"
                              >نمایش
                            </label>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--start Tag Uploader -->
                  <div class="col-md-6 col-12">
                    <div class="row">
                      <div class="col-md-4 mt-3 col-12">
                        <uploader
                          :Idu="'Logo'"
                          v-if="$store.state.renderComponent"
                          :base64="GetBase(181070512)"
                          @Done="GetFile"
                          :attachId="GetId(181070512)"
                          :address="GetAddress(181070512)"
                          :grp="181070512"
                          :title="'تصویر لوگو برگه سهام'"
                          :MasterId="DataAxiosSaham.id"
                          :TableName="'wwwtblTanzimat'"
                        ></uploader>
                      </div>
                      <div class="col-md-4 mt-3 col-12">
                        <uploader
                          :Idu="'Emza1'"
                          v-if="$store.state.renderComponent"
                          :base64="GetBase(181070510)"
                          @Done="GetFile"
                          :attachId="GetId(181070510)"
                          :address="GetAddress(181070510)"
                          :grp="181070510"
                          :title="'امضا اول'"
                          :MasterId="DataAxiosSaham.id"
                          :TableName="'wwwtblTanzimat'"
                        ></uploader>
                      </div>
                      <div class="col-md-4 mt-3 col-12">
                        <uploader
                          :Idu="'Emza2'"
                          v-if="$store.state.renderComponent"
                          :base64="GetBase(181070511)"
                          @Done="GetFile"
                          :attachId="GetId(181070511)"
                          :address="GetAddress(181070511)"
                          :grp="181070511"
                          :title="'امضا دوم'"
                          :MasterId="DataAxiosSaham.id"
                          :TableName="'wwwtblTanzimat'"
                        ></uploader>
                      </div>
                    </div>
                  </div>

                  <!--End Tag Uploader -->
                </div>
                <div class="row">
                  <div class="col-md-10 col-12"></div>
                  <div class="col-md-2 col-12 mt-2 text-right">
                    <button
                      type="button"
                      class="btn btn-success rounded mt-4 w-100"
                      style="font-size: 16px"
                      @click="SetSaham"
                    >
                      ثبت اطلاعات برگه سهام
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Nemayesh Buttons Variz-Bardasht-Gardesh -->
            <net-pa-card
              class="mt-4"
              v-if="
                Number(
                  $session.get('UserInfoNetPa').custCode == 868 ||
                    $session.get('UserInfoNetPa').custCode == 8002 ||
                    $session.get('UserInfoNetPa').custCode == 886 ||
                    $session.get('UserInfoNetPa').custCode == 574 ||
                    $session.get('UserInfoNetPa').custCode == 932,
                )
              "
              :IsMinus="true"
              :IdElement="'SettingsButton'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-list-alt"></i> تنظیم واریز | برداشت | گردش
                  حساب‌ها
                </h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-3 col-12">
                    <small>انتخاب حساب </small>
                    <select
                      class="form-control Pointer mt-2"
                      style="font-size: 16px"
                      v-model="DataAxiosButtons.wwwtblnoe"
                      @change="ChangeWwwtblNoeButtons"
                    >
                      <option :value="null">-- انتخاب حساب --</option>
                      <option
                        v-for="item in this.ListTashilat"
                        :key="item.id"
                        :value="item"
                      >
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div
                    class="col-md-3 col-12"
                    v-if="DataAxiosButtons.wwwtblnoe != null"
                  >
                    <small> تنظیمات دکمه واریز وجه</small>
                    <span class="form-control p-1 mt-2">
                      <div class="custom-control custom-switch text-center">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="isPayment"
                          v-model="DataAxiosButtons.isPayment"
                        />
                        <label class="custom-control-label p-1" for="isPayment"
                          >نمایش دکمه واریز
                        </label>
                      </div>
                    </span>
                  </div>
                  <div
                    class="col-md-3 col-12"
                    v-if="DataAxiosButtons.wwwtblnoe != null"
                  >
                    <small> تنظیمات دکمه برداشت وجه</small>
                    <span class="form-control p-1 mt-2">
                      <div class="custom-control custom-switch text-center">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="isDeptor"
                          v-model="DataAxiosButtons.isDebtor"
                        />
                        <label class="custom-control-label p-1" for="isDeptor"
                          >نمایش دکمه برداشت
                        </label>
                      </div>
                    </span>
                  </div>
                  <div
                    class="col-md-3 col-12"
                    v-if="DataAxiosButtons.wwwtblnoe != null"
                  >
                    <small> تنظیمات دکمه گردش</small>
                    <span class="form-control p-1 mt-2">
                      <div class="custom-control custom-switch text-center">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="isTernover"
                          v-model="DataAxiosButtons.isTurnover"
                        />
                        <label class="custom-control-label p-1" for="isTernover"
                          >نمایش دکمه گردش
                        </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 col-12"></div>
                  <div
                    class="col-md-2 col-12 text-center mt-2"
                    v-if="DataAxiosButtons.wwwtblnoe != null"
                  >
                    <button
                      class="btn btn-success rounded mt-4 w-100"
                      style="font-size: 16px"
                      @click="SetSettingButtons"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
          <div
            class="tab-pane fade"
            id="nav-Account-Setting"
            role="tabpanel"
            aria-labelledby="nav-Account-Setting-tab"
          >
            <net-pa-card
              :IsMinus="false"
              :IdElement="'AccountSetting'"
              :IsCollapse="false"
            >
              <template slot="header">
                <h6>تنظیمات حساب بانکی جهت نمایش در فیش</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-3 col-12">
                    <small>نام بانک</small>
                    <select
                      class="form-control"
                      v-model="Account.Id"
                      @change="GetResultBank"
                    >
                      <option selected :value="0">
                        بانک خودرا انتخاب کنید
                      </option>
                      <option
                        v-for="(item, key) in BankList"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.bankName }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3 col-12" v-if="Account.Id > 0">
                    <small>شماره حساب</small>
                    <input
                      class="form-control text-left"
                      v-model="Account.HesabNo"
                      type="text"
                      @keypress="$ValidNumber($event, 20, false)"
                    />
                  </div>
                  <div class="col-md-6 col-12" v-if="Account.Id > 0">
                    <small>اطلاعات حساب</small>
                    <input
                      class="form-control text-right"
                      v-model="Account.BankDetail"
                      placeholder="حقیقی : نام شخص | حقوقی : نام شرکت یا سازمان"
                    />
                  </div>
                  <div class="col-md-3 col-12 mt-2" v-if="Account.Id > 0">
                    <small>شماره کارت</small>
                    <input
                      class="form-control text-center"
                      v-model="Account.CardNo"
                      type="text"
                      v-mask="'####-####-####-####'"
                    />
                  </div>
                  <div class="col-md-5 col-12 mt-2" v-if="Account.Id > 0">
                    <small>شماره شبا</small>
                    <input
                      class="form-control text-center"
                      v-model="Account.ShebaNo"
                      type="text"
                      v-mask="'IR########################'"
                    />
                  </div>
                  <div class="col-md-4 col-12 mt-2" v-if="Account.Id > 0">
                    <button
                      class="btn btn-success mt-3 float-left"
                      @click="SetTableSetting"
                    >
                      ثبت اطلاعات حساب
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
          <div
            class="tab-pane fade"
            id="nav-Settings"
            role="tabpanel"
            aria-labelledby="nav-Settings-tab"
          >
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-cog"></i> تنظیمات سامانه
                </h6>
              </template>
              <template slot="content">
                <div class="sys-list" dir="rtl">
                  <div class="sys-row">
                    <div class="sys-copy">
                      <span class="sys-title">حالت امنیتی تغییر رمز کاربران</span>
                      <span class="sys-hint">{{
                        ActivePasswordSecurityMode
                          ? "امنیتی و سختگیرانه بر اساس حروف کوچک و بزرگ و اعداد"
                          : "غیر امنیتی و راحت (پیشنهاد نمی‌شود)"
                      }}</span>
                    </div>
                    <div class="sys-actions">
                      <span
                        class="sys-state"
                        :class="ActivePasswordSecurityMode ? 'is-on' : 'is-off'"
                      >
                        {{ ActivePasswordSecurityMode ? "فعال" : "غیرفعال" }}
                      </span>
                      <label class="gw-switch">
                        <input
                          type="checkbox"
                          id="SecurityPass"
                          v-model="ActivePasswordSecurityMode"
                          @change="ChangeActivePasswordSecurityMode($event)"
                          aria-label="حالت امنیتی تغییر رمز کاربران"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </label>
                    </div>
                  </div>

                  <div class="sys-row">
                    <div class="sys-copy">
                      <span class="sys-title">تصویر صفحه ورود</span>
                      <span class="sys-hint">{{
                        loginDefaultImageMode
                          ? "تصویر پیش‌فرض سامانه نمایش داده می‌شود"
                          : "تصویر دلخواه — فرمت jpg و ابعاد ۵۰۰×۷۰۰ پیکسل"
                      }}</span>
                      <span
                        v-if="fileinfo.name && !loginDefaultImageMode"
                        class="sys-file"
                        >{{ fileinfo.name }}</span
                      >
                    </div>
                    <div class="sys-actions">
                      <button
                        v-if="!loginDefaultImageMode"
                        type="button"
                        class="gw-btn gw-btn--edit"
                        @click.prevent="clickUploader()"
                      >
                        <i class="fas fa-upload" aria-hidden="true"></i>
                        بارگذاری تصویر
                      </button>
                      <span
                        class="sys-state"
                        :class="loginDefaultImageMode ? 'is-on' : 'is-off'"
                      >
                        {{ loginDefaultImageMode ? "پیش‌فرض" : "دلخواه" }}
                      </span>
                      <label class="gw-switch">
                        <input
                          type="checkbox"
                          id="loginPhoto"
                          v-model="loginDefaultImageMode"
                          @change="setLoginImgMode()"
                          aria-label="تصویر صفحه ورود"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <input
                  type="file"
                  @change="changefile($event)"
                  class="d-none"
                  id="Uploader"
                  accept=".gif,.jpg,.jpeg,.png"
                />
              </template>
            </net-pa-card>
          </div>
          <!--******************************************************************************************-->
          <div
            class="tab-pane fade"
            id="nav-Robot-Setting"
            role="tabpanel"
            aria-labelledby="Robot-tab"
          >
            <net-pa-card
              :IsMinus="false"
              :IdElement="'RobotSetting'"
              :IsCollapse="false"
            >
              <template slot="header">
                <h6>تنظیمات بازو</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <small>توکن بازو</small>
                    <input
                      class="form-control text-right"
                      placeholder="توکن بازو خود را وارد کنید"
                      v-model="botSetting_Token"
                      @keypress="$BlockSuspiciousInput($event, 100)"
                      @keyup="$BlockSuspiciousInput($event, 100)"
                    />
                  </div>
                  <div class="col-md-3 col-12">
                    <small>نام کاربری بازو</small>
                    <input
                      class="form-control text-right"
                      v-model="botSetting_UserName"
                      @keypress="$BlockSuspiciousInput($event, 50)"
                      @keyup="$BlockSuspiciousInput($event, 50)"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-9 col-12">
                    <small>درباره ما</small>
                    <textarea
                      class="form-control text-right"
                      placeholder="متن درباره ما نمایش داده شده در بازو"
                      v-model="botSetting_AboutUs"
                      @keypress="$BlockSuspiciousInput($event, 2000)"
                      @keyup="$BlockSuspiciousInput($event, 2000)"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 col-12 text-center"></div>
                  <div class="col-md-2 col-12 text-center">
                    <button
                      class="btn btn-success rounded mt-4 w-100"
                      @click="setRobot()"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
          <!-- <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import uploader from "./Componenets/NetpaUploader.vue";
import Loading from "../Tools/NetPa/Loading.vue";

export default {
  components: {
    NetPaCard,
    Panel,
    uploader,
    Loading,
  },
  data() {
    return {
      EnableRobot: "",
      botSetting_Token: "",
      botSetting_UserName: "",
      botSetting_AboutUs: "",
      BankList: [],
      file: [],
      Menu: [],
      EditMode: false,
      gatewaySnapshot: null,
      toolbarPinned: false,
      toolbarHeight: 0,
      pinStyle: null,
      DataAxios: { wwwtblnoe: -1 },
      DataAxiosBardasht: { wwwtblnoe: -1 },
      ListModel2: null,
      ListTashilat: null,
      DataAxiosTashilat: { wwwtblnoe: -1 },
      DataAxiosSaham: {},
      DataAxiosButtons: {
        wwwtblnoe: null,
        wwwtblnoeId: null,
        isPayment: true,
        isDebtor: true,
        isTurnover: true,
      },
      Account: {
        HesabNo: "",
        ShebaNo: "",
        CardNo: "",
        BankName: "",
        BankDetail: "",
        Id: 0,
      },
      ActivePasswordSecurityMode: this.$GetActivePasswordSecurityMode(),
      fileinfo: {},
      showUploaderLogin: false,
      loadingRender: false,
      loginDefaultImageMode: this.$getLoginImgMode(),
      IsImgLoginUploaded: false,
      DataAxiosUpload: {
        ArryfildValue: "",
        Method: "Post",
        Action: "GetTblCustomer/UploadLoginImage",
        Token: "",
      },
    };
  },
  methods: {
    observeGatewayToolbar() {
      if (
        typeof IntersectionObserver === "undefined" ||
        !this.$refs.gatewaySentinel
      ) {
        return;
      }
      this.toolbarObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const paneHidden =
            entry.boundingClientRect.width === 0 &&
            entry.boundingClientRect.height === 0;
          if (paneHidden) {
            this.toolbarPinned = false;
            return;
          }
          const shouldPin =
            !entry.isIntersecting && entry.boundingClientRect.top < 8;
          if (shouldPin === this.toolbarPinned) {
            if (shouldPin) this.updateGatewayPinBox();
            return;
          }
          if (shouldPin) this.updateGatewayPinBox();
          this.toolbarPinned = shouldPin;
        },
        { threshold: 0 },
      );
      this.toolbarObserver.observe(this.$refs.gatewaySentinel);
      if (typeof ResizeObserver !== "undefined" && this.$refs.gatewayAnchor) {
        this.anchorResizeObserver = new ResizeObserver(() => {
          if (this.toolbarPinned) this.updateGatewayPinBox();
        });
        this.anchorResizeObserver.observe(this.$refs.gatewayAnchor);
      }
    },
    updateGatewayPinBox() {
      const anchor = this.$refs.gatewayAnchor;
      const toolbar = anchor && anchor.querySelector(".gw-toolbar");
      if (!anchor || !toolbar) return;
      const rect = anchor.getBoundingClientRect();
      this.toolbarHeight = toolbar.offsetHeight;
      this.pinStyle = {
        top: "12px",
        left: rect.left + "px",
        width: rect.width + "px",
      };
    },
    startGatewayEdit() {
      this.gatewaySnapshot = JSON.parse(JSON.stringify(this.Menu));
      this.EditMode = true;
    },
    cancelGatewayEdit() {
      if (this.gatewaySnapshot) {
        this.Menu = JSON.parse(JSON.stringify(this.gatewaySnapshot));
      }
      this.EditMode = false;
    },
    readMenus() {
      var DataAxiosRead = {
        ArryfildValue: {
          shobeId: this.$session.get("UserInfoNetPa").wwwtblShobeId,
        },
        Method: "GET",
        Action: "GatewayOld",
      };
      this.$GetData_Header(DataAxiosRead).then((data) => {
        this.Menu = data.data;
      });
    },
    updatemenu() {
      this.$store.state.loading = true;
      var DataAxiosUpdate = {
        ArryfildValue: {},
        Method: "Post",
        Action: "UpdateGateway",
      };
      DataAxiosUpdate.ArryfildValue = this.Menu;
      this.$PutData_Body(DataAxiosUpdate).then((data) => {
        this.$store.state.loading = false;
        if (data.status == "Ok") {
          this.$mySweetDefault(
            "عملیات موفق!",
            "تغییرات با موفقیت ذخیره شد. برای اعمال یکبار از برنامه خارج شوید و دوباره وارد شوید",
            "success",
            3000,
          );
        } else {
          this.$mySweetDefault(
            "خطا!",
            "در ثبت اطلاعات مشکلی رخ داده است. لطفا دوباره تلاش کنید",
            "danger",
            2000,
          );
        }
        this.EditMode = !this.EditMode;
        this.readMenus();
      });
    },
    GetTaahodatList() {
      var DataAxios_Noe = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      DataAxios_Noe.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Noe).then((data) => {
        this.ListModel2 = data.data;
      });
    },
    SetTaahodatList(IsBardasht) {
      var DataAxios_Noe = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/SetSettings",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      if (IsBardasht) {
        formData.append("wwwtblNoeId", this.DataAxiosBardasht.wwwtblnoeId);
        formData.append(
          "WithdrawalIfLoanIsDelayed",
          this.$session.get("CustCode") == "948"
            ? this.DataAxiosBardasht.wwwtblnoe.withdrawalIfLoanIsDelayed
            : false,
        );

        formData.append(
          "Amount",
          this.DataAxiosBardasht.Amount != "" &&
            this.DataAxiosBardasht.Amount != null
            ? this.DataAxiosBardasht.Amount.replace(/,/g, "").replace(/\./g, "")
            : this.DataAxiosBardasht.wwwtblnoe.maxMabBardashtDarRoz,
        );
      } else {
        formData.append("wwwtblNoeId", this.DataAxios.wwwtblnoeId);
        formData.append(
          "Amount",
          this.DataAxios.Amount.replace(/,/g, "").replace(/\./g, ""),
        );
      }

      formData.append("IsBardasht", IsBardasht);
      DataAxios_Noe.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Noe).then((data) => {
        if (data.status == "Ok") {
          this.GetTaahodatList();
          this.DataAxios = {};
          this.DataAxiosBardasht = { wwwtblnoe: -1 };
          this.$mySweetDefaultTost(
            " ثبت موفق",
            "تغییرات شما با موفقیت ثبت گردید",
            "success",
            2000,
          );
        }
      });
    },
    ChangeNoe(IsBardasht) {
      if (IsBardasht) {
        this.DataAxiosBardasht.wwwtblnoeId =
          this.DataAxiosBardasht.wwwtblnoe.id;
        this.DataAxiosBardasht.wwwtblnoe.maxMabEnteghalDarMah =
          this.$Comma3ragham(
            this.DataAxiosBardasht.wwwtblnoe.maxMabEnteghalDarMah,
          );
      } else {
        this.DataAxios.wwwtblnoeId = this.DataAxios.wwwtblnoe.id;
        this.DataAxios.wwwtblnoe.maxMabEnteghalDarMah = this.$Comma3ragham(
          this.DataAxios.wwwtblnoe.maxMabEnteghalDarMah,
        );
      }
    },
    GetTashilatList() {
      var DataAxios_Noe = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/GettblNoe",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("NoeId", 2);
      DataAxios_Noe.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Noe).then((data) => {
        this.ListTashilat = data.data;
      });
    },
    SetTashilatList() {
      var DataAxios_Noe = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/SetSettingsTashilat",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblNoeId", this.DataAxiosTashilat.wwwtblnoeId);
      formData.append("SP", this.DataAxiosTashilat.SP);
      formData.append(
        "MessageZeroScore",
        this.DataAxiosTashilat.MessageZeroScore,
      );
      formData.append(
        "ShowMessageZeroScore",
        this.DataAxiosTashilat.ShowMessageZeroScore,
      );
      formData.append("ShowScore", this.DataAxiosTashilat.ShowScore);
      DataAxios_Noe.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Noe).then((data) => {
        if (data.status == "Ok") {
          this.GetTashilatList();
          this.DataAxiosTashilat = {};
          this.$mySweetDefaultTost(
            " ثبت موفق",
            "تغییرات شما با موفقیت ثبت گردید",
            "success",
            2000,
          );
        } else {
          this.$mySweetDefaultTost("خطایی رخ داده", data.msg, "danger", 2000);
        }
      });
    },
    ChangeTashilatNoe() {
      if (this.DataAxiosTashilat.wwwtblnoe.id) {
        this.DataAxiosTashilat.wwwtblnoeId =
          this.DataAxiosTashilat.wwwtblnoe.id;
        this.DataAxiosTashilat.SP =
          this.DataAxiosTashilat.wwwtblnoe.spName.trim();
        this.DataAxiosTashilat.MessageZeroScore =
          this.DataAxiosTashilat.wwwtblnoe.messageZeroScore.trim();
        this.DataAxiosTashilat.ShowMessageZeroScore =
          this.DataAxiosTashilat.wwwtblnoe.showMessageZeroScore;
        this.DataAxiosTashilat.ShowScore =
          this.DataAxiosTashilat.wwwtblnoe.showScore;
        //console.log('😎 ~ ChangeTashilatNoe ~ this.DataAxiosTashilat:', this.DataAxiosTashilat)
      } else {
        this.DataAxiosTashilat = {};
      }
    },
    GetFile() {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: this.DataAxiosSaham.id,
          tableName: "wwwtblTanzimat",
        },
      };
      this.$PostData(dataAxios).then((result) => {
        if (result.data[0]) {
          if (result.data[0].wwwtblcomboidgrp328 == 181070512) {
            this.DataAxiosSaham.wwwtblImageIdLogo = result.data[0].id;
          } else if (result.data[0].wwwtblcomboidgrp328 == 181070510) {
            this.DataAxiosSaham.wwwtblImageIdEmza1 = result.data[0].id;
          } else if (result.data[0].wwwtblcomboidgrp328 == 181070511) {
            this.DataAxiosSaham.wwwtblImageIdEmza2 = result.data[0].id;
          }
        }
        this.file = result.data;
        this.$store.state.renderComponent = false;
        this.$nextTick(() => {
          this.$store.state.renderComponent = true;
        });
      });
    },
    GetBase(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        return binary;
      } else {
        return null;
      }
    },
    GetAddress(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        if (
          binary.filename.indexOf(".PDF") > 0 ||
          binary.filename.indexOf(".pdf") > 0
        ) {
          return "/Image/PdfFile.png";
        }
        if (
          binary.filename.indexOf(".zip") > 0 ||
          binary.filename.indexOf(".rar") > 0
        ) {
          return "/Image/ZipFile.png";
        }
        return "data:image/png;base64," + binary.binary;
      } else {
        return null;
      }
    },
    GetId(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        return binary.id;
      } else {
        return null;
      }
    },
    SetSaham() {
      if (this.$ValidForm("BargeSaham")) {
        var DataAxios_NoeSaham = {
          ArryfildValue: "",
          Method: "Post",
          Action: "TanzimatNoe/UpdateSaham",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("wwwtblNoeId", this.DataAxiosSaham.wwwtblNoeId);
        formData.append("ShomareSabt", this.DataAxiosSaham.shomareSabt);
        formData.append("TarixSabt", this.DataAxiosSaham.tarixSabt);
        formData.append("ArzeshHarSahm", this.DataAxiosSaham.arzeshHarSahm);
        formData.append("PishNevis1", this.DataAxiosSaham.pishNevis1);
        formData.append("PishNevis2", this.DataAxiosSaham.pishNevis2);
        formData.append("ShenaseMeli", this.DataAxiosSaham.shenaseMeli);

        formData.append("SerialNumber", this.DataAxiosSaham.serialNumber);
        formData.append(
          "wwwtblImageIdLogo",
          this.DataAxiosSaham.wwwtblImageIdLogo,
        );
        formData.append(
          "wwwtblImageIdEmza1",
          this.DataAxiosSaham.wwwtblImageIdEmza1
            ? this.DataAxiosSaham.wwwtblImageIdEmza1
            : 0,
        );
        formData.append(
          "wwwtblImageIdEmza2",
          this.DataAxiosSaham.wwwtblImageIdEmza2
            ? this.DataAxiosSaham.wwwtblImageIdEmza2
            : 0,
        );
        formData.append(
          "MessageZeroScore",
          this.DataAxiosSaham.MessageZeroScore,
        );
        formData.append(
          "ShowMessageZeroScore",
          this.DataAxiosSaham.ShowMessageZeroScore,
        );
        formData.append("ShowScore", this.DataAxiosSaham.ShowScore);
        DataAxios_NoeSaham.ArryfildValue = formData;
        this.$PostFormData(DataAxios_NoeSaham).then((data) => {
          if (data.status == "Ok") {
            this.$mySweetDefaultTost(
              " ثبت موفق",
              "تغییرات شما با موفقیت ثبت گردید",
              "success",
              2000,
            );
          } else {
            this.$mySweetDefaultTost("خطایی رخ داده", data.msg, "danger", 2000);
          }
        });
      }
    },
    getSahamsettings() {
      var DataAxios_GetSaham = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/GetSahamSettings",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      DataAxios_GetSaham.ArryfildValue = formData;
      this.$PostFormData(DataAxios_GetSaham).then((data) => {
        this.DataAxiosSaham = data.data;
        this.DataAxiosSaham.arzeshHarSahm = this.$Comma3ragham(
          this.DataAxiosSaham.arzeshHarSahm,
        );
        this.DataAxiosSaham.MessageZeroScore = data.noe.messageZeroScore;
        this.DataAxiosSaham.ShowMessageZeroScore =
          data.noe.showMessageZeroScore;
        this.DataAxiosSaham.ShowScore = data.noe.showScore;
      });
    },
    ChangeWwwtblNoeButtons() {
      this.DataAxiosButtons.wwwtblnoeId = this.DataAxiosButtons.wwwtblnoe.id;
      this.DataAxiosButtons.isPayment =
        this.DataAxiosButtons.wwwtblnoe.isPayment;
      this.DataAxiosButtons.isDebtor = this.DataAxiosButtons.wwwtblnoe.isDebtor;
      this.DataAxiosButtons.isTurnover =
        this.DataAxiosButtons.wwwtblnoe.isTurnover;
    },
    SetSettingButtons() {
      var DataAxios_Buttons = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/UpdateSettings",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblNoeId", this.DataAxiosButtons.wwwtblnoeId);
      formData.append("isPayment", this.DataAxiosButtons.isPayment);
      formData.append("isDebtor", this.DataAxiosButtons.isDebtor);
      formData.append("isTurnover", this.DataAxiosButtons.isTurnover);
      DataAxios_Buttons.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Buttons).then((data) => {
        if (data.status == "Ok") {
          this.GetTashilatList();
          this.DataAxiosButtons = {};
          this.$mySweetDefaultTost(
            " ثبت موفق",
            "تغییرات شما با موفقیت ثبت گردید",
            "success",
            2000,
          );
        }
      });
    },
    SetTableSetting() {
      if (this.Account.Id > 0) {
        var DataAxios_Set = {
          ArryfildValue: "",
          Method: "Post",
          Action: "Bank/UpdateBank",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("BankId", this.Account.Id);
        formData.append("hesabNo", this.Account.HesabNo);
        formData.append("shebaNo", this.Account.ShebaNo);
        formData.append("cardNo", this.Account.CardNo.replaceAll("-", ""));
        formData.append("bankName", this.Account.BankName);
        formData.append("bankDetail", this.Account.BankDetail);
        DataAxios_Set.ArryfildValue = formData;
        this.$PostFormData(DataAxios_Set).then((data) => {
          if (data.status == "Ok") {
            this.$mySweetDefaultTost(
              " ثبت موفق",
              "اطلاع حساب بانکی شما با موفقیت ثبت گردید",
              "success",
              2000,
            );
            return;
          }
          this.$mySweetDefaultTost(
            "خطا در ثبت",
            "در ثبت اطلاعات خطایی رخ داد",
            "error",
            2000,
          );
        });
      } else {
        this.$mySweetDefaultTost(
          "عدم انتخاب بانک",
          "یانکی انتخاب نشده ، لطفا بانک خودرا انتخاب کنید",
          "error",
          2000,
        );
      }
    },
    GetTableBank() {
      var DataAxios_Get = {
        ArryfildValue: "",
        Method: "Get",
        Action: "Bank/GetBankList",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$GetData_Body(DataAxios_Get).then((res) => {
        this.BankList = res;
      });
    },
    GetResultBank() {
      if (this.Account.Id == 0) {
        this.$mySweetDefaultTost(
          "عدم انتخاب بانک",
          "لطفا یکی از بانک ها را انتخاب کنید",
          "",
          2000,
        );
        return;
      }
      var DataAxios_Set = {
        ArryfildValue: "",
        Method: "Post",
        Action: "Bank/GetBankId",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("BankId", this.Account.Id);
      DataAxios_Set.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Set).then((data) => {
        if (data.status == "Ok") {
          this.$mySweetDefaultTost(
            "موفق",
            "اطلاع حساب بانکی شما خوانده شد",
            "success",
            2000,
          );
          this.Account.HesabNo = data.data.hesabNo;
          this.Account.ShebaNo = data.data.shebaNo;
          this.Account.CardNo = data.data.cardNo;
          this.Account.BankName = data.data.bankName;
          this.Account.BankDetail = data.data.bankDetail;
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "خطایی در خواندن اطلاعات رخ داده ، لطفا کمی بعد تلاش کنید",
            "warning",
            2000,
          );
        }
      });
      // this.Account.Id=item.id
    },
    getBankId() {},
    ChangeActivePasswordSecurityMode(e) {
      var DataAxios_Upd = {
        ArryfildValue: "",
        Method: "Post",
        Action: "GetTblCustomer/UpdateActivePasswordSecurityMode",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append(
        "ActivePasswordSecurityMode",
        this.ActivePasswordSecurityMode,
      );
      formData.append("CustCode", Number(this.$session.get("CustCode")));

      DataAxios_Upd.ArryfildValue = formData;

      this.$PostFormData(DataAxios_Upd).then((res) => {
        if (res.status == "Ok") {
          this.$mySweetDefaultTost("موفق", res.message, "success", 2000);
          this.$SetActivePasswordSecurityMode(this.ActivePasswordSecurityMode);
        } else {
          this.$mySweetDefaultTost("خطا", res.message, "error", 2000);
        }
      });
    },
    clickUploader() {
      document.getElementById("Uploader").click();
    },
    setLoginImgMode() {
      if (
        this.loginDefaultImageMode ||
        (!this.loginDefaultImageMode && this.IsImgLoginUploaded)
      ) {
        var DataAxios_loginImg = {
          ArryfildValue: "",
          Method: "Post",
          Action: "GetTblCustomer/UpdateLoginImgMode",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("imgMode", this.loginDefaultImageMode);
        formData.append("CustCode", Number(this.$session.get("CustCode")));

        DataAxios_loginImg.ArryfildValue = formData;
        this.$PostFormData(DataAxios_loginImg).then((res) => {
          if (res.status == "Ok") {
            this.$mySweetDefaultTost("موفق", res.message, "success", 2000);

            this.$setLoginImgMode(this.loginDefaultImageMode);
          } else {
            this.$mySweetDefaultTost("خطا", res.message, "error", 2000);
          }
        });
        this.IsImgLoginUploaded = false;
      }
    },
    changefile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const img = new Image();
      const objectUrl = URL.createObjectURL(
        document.getElementById("Uploader").files[0],
      );
      img.onload = () => {
        if (img.width !== 500 || img.height !== 700) {
          this.$mySweetDefaultTost(
            "ابعاد تصویر نامعتبر است",
            "ابعاد تصویر باید دقیقاً 500×700 پیکسل باشد",
            "error",
            3000,
          );
        }
        URL.revokeObjectURL(objectUrl);
        e.target.value = "";
        return;
      };
      img.src = objectUrl;

      const allowedExtensions = ["jpg"];

      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.لطفا فرمت را به jpg  تغییر بدهید.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }

      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 5) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل مورد نظر بیشتر از 5 مگابایت است ",
          "error",
          3000,
        );
        return;
      } else {
        this.IsImgLoginUploaded = true;
        this.fileinfo = document.getElementById("Uploader").files[0];

        let formData = new FormData();
        formData.append("file", this.fileinfo);

        this.DataAxiosUpload.ArryfildValue = formData;

        this.loadingRender = true;

        this.$PostFormData(this.DataAxiosUpload).then((data) => {
          this.loadingRender = false;
          if (data.status === "ok") {
            this.setLoginImgMode();
          }
        });
      }
    },
    setRobot() {
      if (
        this.botSetting_Token.trim() == "" ||
        this.botSetting_UserName.trim() == "" ||
        this.botSetting_AboutUs.trim() == ""
      ) {
        this.$mySweetDefaultTost(
          "خطا",
          "لطفا تمامی فیلدها را پر کنید",
          "error",
          2000,
        );
        return;
      } else {
        var DataAxios_Robot = {
          ArryfildValue: "",
          Method: "Post",
          Action: "GetTblCustomer/UpdateRobotSetting",
          Token: "",
        };
        const formData = new FormData();

        formData.append("BotToken", this.botSetting_Token);
        formData.append("BotUserName", this.botSetting_UserName);
        formData.append("BotAboutUsText", this.botSetting_AboutUs);
        formData.append("CustCode", Number(this.$session.get("CustCode")));

        DataAxios_Robot.ArryfildValue = formData;

        this.$PostFormData(DataAxios_Robot).then((res) => {
          if (res.status == "Ok") {
            this.$mySweetDefaultTost("ثبت موفق", res.message, "success", 2000);
          } else {
            this.$mySweetDefaultTost("خطا", res.message, "message", 2000);
          }
        });
      }
    },
  },
  created() {
    this.$GetAppsettingsAsync();
    var botSettingArray = this.$GetBotSetting();
    this.botSetting_Token = botSettingArray.token;
    this.botSetting_UserName = botSettingArray.userName;
    this.botSetting_AboutUs = botSettingArray.aboutUs;
    this.EnableRobot = sessionStorage.getItem("EnableRobot");
    this.readMenus();
    this.GetTaahodatList();
    this.GetTashilatList();
    this.GetFile();
    this.getSahamsettings();
    this.GetTableBank();
  },
  watch: {
    EditMode() {
      this.$nextTick(() => {
        if (this.toolbarPinned) this.updateGatewayPinBox();
      });
    },
  },
  updated() {
    //k.hr
  },
  mounted() {
    this.$nextTick(() => {
      const toolbar =
        this.$refs.gatewayAnchor &&
        this.$refs.gatewayAnchor.querySelector(".gw-toolbar");
      if (toolbar) this.toolbarHeight = toolbar.offsetHeight;
      this.observeGatewayToolbar();
    });
  },
  beforeDestroy() {
    if (this.toolbarObserver) this.toolbarObserver.disconnect();
    if (this.anchorResizeObserver) this.anchorResizeObserver.disconnect();
  },
};
</script>
<style scoped>
.gw-toolbar-anchor {
  margin-bottom: 12px;
}

.gw-sentinel {
  height: 1px;
  margin: 0;
  pointer-events: none;
}

.gw-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #dbe5eb;
  border-radius: 16px;
  background: rgba(247, 249, 251, 0.96);
}

.gw-toolbar.is-fixed {
  position: fixed;
  z-index: 40;
  margin: 0;
  box-shadow: 0 14px 28px rgba(41, 52, 95, 0.16);
}

.gw-toolbar.is-editing {
  border-color: rgba(5, 184, 200, 0.35);
  background: linear-gradient(100deg, rgba(237, 247, 251, 0.98), #fff 62%);
}

.gw-summary {
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
}

.gw-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gw-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 16px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color 180ms ease,
    background 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
}

.gw-btn:focus {
  outline: none;
}

.gw-btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}

.gw-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.gw-btn--edit,
.gw-btn--ghost {
  color: #29345f;
  border: 1px solid #dbe5eb;
  background: #fff;
}

.gw-btn--edit:not(:disabled):hover,
.gw-btn--ghost:not(:disabled):hover {
  color: #8d58a4;
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.gw-btn--save {
  min-height: 44px;
  padding: 10px 18px;
  color: #fff;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 10px 20px rgba(41, 52, 95, 0.16);
}

.gw-btn--save:not(:disabled):hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(41, 52, 95, 0.22);
}

.gw-empty {
  margin: 8px 0 0;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

.gw-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.gw-item {
  padding: 14px;
  border: 1px solid #e8eef2;
  border-radius: 14px;
  background: #fff;
}

.gw-item__head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.gw-index {
  display: grid;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  place-items: center;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
  border-radius: 8px;
  background: #f5f7fb;
}

.gw-name {
  flex: 1 1 auto;
  min-width: 0;
  color: #596a7d;
  font-size: 14px;
  font-weight: 600;
}

.gw-name span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gw-name input,
.gw-field input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  color: #4d6072;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
}

.gw-name input:focus,
.gw-field input:focus {
  outline: none;
  border-color: #05b8c8;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.gw-fields {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.6fr) minmax(0, 0.8fr);
  gap: 12px;
  margin-top: 14px;
}

.gw-field {
  min-width: 0;
  margin: 0;
}

.gw-field small {
  display: block;
  margin-bottom: 6px;
  color: #8b98a8;
  font-size: 12px;
  font-weight: 600;
}

.gw-value {
  display: block;
  min-height: 40px;
  padding: 10px 12px;
  overflow: hidden;
  color: #4d6072;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 10px;
  background: #f7f9fb;
}

.gw-value.is-center,
.gw-field input.is-center {
  text-align: center;
}

.gw-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e8eef2;
}

.gw-flag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #596a7d;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.gw-flag.is-disabled {
  cursor: default;
}

.gw-switch {
  position: relative;
  display: inline-flex;
  margin: 0;
  cursor: pointer;
}

.gw-switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}

.gw-switch__track {
  position: relative;
  display: block;
  width: 44px;
  height: 26px;
  border-radius: 999px;
  background: #d5dee6;
  transition: background 180ms ease;
}

.gw-switch__track::after {
  content: "";
  position: absolute;
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(19, 36, 58, 0.22);
  transition: transform 180ms ease;
}

.gw-switch input:checked + .gw-switch__track {
  background: linear-gradient(110deg, #29345f, #05b8c8);
}

.gw-switch input:checked + .gw-switch__track::after {
  transform: translateX(-18px);
}

.gw-switch input:focus-visible + .gw-switch__track {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}

.gw-switch input:disabled + .gw-switch__track {
  cursor: not-allowed;
  opacity: 0.55;
}

.gw-flag.is-disabled .gw-switch {
  cursor: not-allowed;
}

.sys-list {
  display: flex;
  flex-direction: column;
}

.sys-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 2px;
  border-bottom: 1px solid #e8eef2;
}

.sys-row:last-child {
  border-bottom: 0;
  padding-bottom: 2px;
}

.sys-copy {
  min-width: 0;
}

.sys-title {
  display: block;
  color: #31465f;
  font-size: 14px;
  font-weight: 700;
}

.sys-hint {
  display: block;
  margin-top: 4px;
  color: #8b98a8;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.7;
}

.sys-file {
  display: inline-block;
  margin-top: 8px;
  color: #596a7d;
  font-size: 12px;
  font-weight: 600;
}

.sys-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.sys-state {
  min-width: 52px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.sys-state.is-on {
  color: #068997;
}

.sys-state.is-off {
  color: #8b98a8;
}

@media (max-width: 767px) {
  .gw-toolbar,
  .sys-row {
    flex-direction: column;
    align-items: stretch;
  }

  .gw-actions,
  .sys-actions {
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  .gw-btn--edit,
  .gw-btn--save {
    flex: 1;
  }

  .gw-fields {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .gw-btn,
  .gw-switch__track,
  .gw-switch__track::after {
    transition: none;
  }

  .gw-btn--save:not(:disabled):hover {
    transform: none;
  }
}
</style>
